export function getExceptionalBurnLabel(targets) {
  const bonus = Number(targets?.details?.exceptional_burn_bonus) || 0;
  return bonus > 0 ? ` (+${Math.round(bonus)} exceptional activity)` : '';
}
